// Copyright (c) 2017 Deere & Company

import AmountCellRenderer from '../../shared/report-cell-renderers/amount-cell-renderer';
import ClaimNumberWithKeyCellRenderer from '../../shared/report-cell-renderers/claim-number-with-key-cell-renderer';
import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getAdvancedClaimSummaryColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: ClaimNumberWithKeyCellRenderer,
            colId: 'claimNumber',
            field: 'claimNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin ',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 220
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'repairNumber',
            field: 'referenceInfo.repairNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REPAIR_NUMBER'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reference1',
            field: 'referenceInfo.referenceNumber1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WORK_ORDER_ONE'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reference2',
            field: 'referenceInfo.referenceNumber2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WORK_ORDER_TWO'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'failurePartNumber',
            field: 'failureInfo.failurePartNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FAILED_PART'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'repairDate',
            field: 'failureInfo.repairDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REPAIRED'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'failureDate',
            field: 'failureInfo.failureDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('FAILED'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'originalSubmissionDate',
            field: 'originalSubmissionDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('SUBMITTED'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'approvalDate',
            field: 'approvalDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('APPROVED'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'claimType',
            field: 'claimType.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM_TYPE'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'subClaimType',
            field: 'subClaimType.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('SUB_CLAIM_TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'programName',
            field: 'programName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PROGRAM'),
            valueGetter: params => params.data.programName ? `${params.data.programName} - ${params.data.programDescription}` : '',
            width: 240
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'claimStatus',
            field: 'claimStatus.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STATUS'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerAccount',
            field: 'responsibleAccount.account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerLocation',
            field: 'responsibleAccount.location',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_LOCATION'),
            valueGetter: params => `${params.data.responsibleAccount.location.city}, ${params.data.responsibleAccount.location.state}`,
            width: 220
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'netAmount',
            field: 'claimValueDetails.netAmount',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('NET_AMOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'reimbursedAmount',
            field: 'claimValueDetails.reimbursedAmount',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('REIMBURSED_AMOUNT'),
            width: 200
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'recovered',
            field: 'claimValueDetails.recoverPercentage',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('RECOVERED'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'createdDate',
            field: 'recordInfo.createdDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CREATED'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'createdBy',
            field: 'recordInfo.createdBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CREATED_BY'),
            valueGetter: params => `${params.data.recordInfo.createdBy.buildUserName()}`,
            width: 270
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'updatedDate',
            field: 'recordInfo.updatedDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CHANGED'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerSummary.displayName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER'),
            width: 300
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/report-services/column-definitions.js